export class MenuModel {
  constructor(
    public nome: string = "",
    public codigo: number = 0,
    public permissoes: Array<number> = [],
    public rota: string = "",
    public posicao: number,
    public codigoPai: number = 0
  ) { }
}
